import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationDefaultCategory(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/consolidacao/get_inadimplance_categories/', {params});
  return data;
}

type QueryFnType = typeof getConsolidationDefaultCategory;

function useConsolidationDefaultCategory(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-inadimplencia-category', params.year],
    queryFn: () => getConsolidationDefaultCategory(params),
  });
}

export { getConsolidationDefaultCategory, useConsolidationDefaultCategory };
